import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Wishlist/AddToWishlistModal/AddToWishlist.modal"
    ).then((module) => ({
        default: module.AddToWishlistModal
    }))
);
